import React from "react";
import Service_Description from '../../Components/Liaison/Service_Description'
import Liaison_Sublanding from "../Liaison_Sublanding";


function Liaison_Microlanding(){
    return (
        <>
              {/* <Service_Description /> */}
              <Liaison_Sublanding />
        </>
    )
}

export default Liaison_Microlanding